/* @ngInject */
export default function RequestPasswordResetCtrl(
  PasswordsResource,
  validationConstants,
  CurrentCourseManager,
  CurrentUserManager,
  config,
  $state,
  vcRecaptchaService,
) {
  const vm = this;
  let widgetId;

  vm.CurrentUserManager = CurrentUserManager;
  vm.email = '';
  vm.validationConstants = validationConstants;
  vm.params = $state.params;
  vm.course = CurrentCourseManager.course;
  vm.requestPasswordReset = requestPasswordReset;
  vm.config = config;

  vm.onWidgetCreate = (_widgetId) => {
    vm.widgetId = _widgetId;
  };

  function requestPasswordReset() {
    vm.error = false;
    vm.emailNotFound = false;
    vm.recaptchaError = false;
    vm.requestingPasswordReset = true;

    const catalogId = CurrentCourseManager.course ? CurrentCourseManager.course.catalogId : undefined;
    PasswordsResource.save(
      {
        user: { email: vm.email },
        catalogId,
        recaptchaResponse: vm.recaptchaResponse,
      },
      (resource) => {
        vm.requestingPasswordReset = false;
        $state.go('users.authentications.confirm-request-password-reset-email', vm.params);
      },
      (resource) => {
        vm.requestingPasswordReset = false;
        vm.error = true;
        vcRecaptchaService.reload(widgetId);

        if (resource.data.error.code === 'login.errors.recaptcha') {
          vm.recaptchaError = true;
        } else if (resource.status === 404) {
          vm.emailNotFound = true;
        }
      },
    );
  }
}
